import SetupBackend from "../services/config/config";

const api = SetupBackend();

function pickData(r) {
  return r && r.data && r.data.data ? r.data.data : r.data;
}

const RampsService = {
  /*
    Saldo e endereço vêm da CUSTÓDIA, não mais das subcontas na corretora.
    As rotas antigas (`/api/v1/criptobnb/subaccounts/{email}/...`) foram removidas
    da API num ajuste de segurança e respondiam 404 — esta tela vinha pedindo
    saldo e endereço a endpoints que não existem mais.

    A rede NÃO é mais parâmetro: a carteira de custódia do cliente responde por
    várias redes e é a mesa que decide qual serve o ativo pedido. Mandar `BEP20`
    daqui era escolher rede no navegador, e mandar cripto para a rede errada é
    perda.
  */
  getBalance(email) {
    return api
      .get(`/v1/baas/custody/balance`, { params: { email } })
      .then(pickData);
  },

  /*
    Situação do cadastro no provedor de rampa. É o que decide QUAL tela mostrar:
    sem cadastro, o formulário de coleta no lugar de saldo e botões; em análise, o
    estado; recusado, o motivo e o que reenviar; aprovado, a tela normal.

    `hasProfile: false` vem com 200 — é o começo do fluxo, não erro.
  */
  getRampProfile(email) {
    return api
      .get(`/v1/baas/custody/ramp-profile`, { params: { email } })
      .then(pickData);
  },

  /* Envia o cadastro. O servidor valida campo a campo com o mesmo schema que o
     compliance usa, e a razão social e o CNPJ vêm do cadastro da empresa, não daqui. */
  submitRampOnboarding(email, customer) {
    return api
      .post(`/v1/baas/custody/ramp-onboarding`, { email, customer })
      .then(pickData);
  },

  /*
    A carteira do cliente POR REDE: cada rede com o seu endereço e os saldos dela.

    Substitui `getDepositAddress`, que pedia "o endereço do USDT" — pergunta que não
    tem resposta única numa carteira que nasce com endereço em seis ou sete redes. Na
    Tron, USDT, USDC e o TRX nativo chegam no MESMO endereço, e mostrar um endereço por
    ativo dava a entender que eram depósitos diferentes.
  */
  getWallet(email) {
    return api
      .get(`/v1/baas/custody/wallet`, { params: { email } })
      .then(pickData);
  },

  /*
    ── Saque: sai da CARTEIRA DE CUSTÓDIA do cliente ──

    Antes ia para `/api/v1/swap/withdraw/usdt`, que saca da subconta na corretora — a
    conta antiga, de um fluxo que esta tela não usa mais. O saldo que a tela MOSTRA é o
    da custódia, então sacar de outro lugar era pedir um saque de um saldo que o cliente
    não estava vendo.

    `twoFactorCode` vai no corpo, com o pedido: o servidor valida na MESMA requisição que
    move o dinheiro. Validar antes, numa chamada à parte, deixaria uma janela entre a
    conferência e a saída — e gastaria o código duas vezes.

    `network` é o recurso de rede da custódia (ex.: `networks/tron-mainnet`), escolhido de
    uma lista que vem da própria carteira. O servidor RECUSA se não for a rede do ativo:
    mandar USDT da Tron para um endereço de Polygon é perda total.
  */
  withdrawCustody(email, { coin, amount, address, network, twoFactorCode }) {
    return api
      .post(`/v1/baas/custody/withdraw`, {
        email,
        coin,
        amount,
        address,
        network,
        twoFactorCode,
      })
      .then(pickData);
  },

  /*
    ── Contas que recebem o saque em EUR e USD ──

    O PIX aceita a chave no próprio saque; SEPA e Wire não — exigem conta cadastrada e
    aprovada antes. `currencies` vem com o trilho e se ele está aprovado para esta empresa,
    para a tela não oferecer um saque que o provedor vai recusar depois de tudo preenchido.
  */
  getRampAccounts(email) {
    return api.get(`/v1/baas/custody/ramp-accounts`, { params: { email } }).then(pickData);
  },

  createRampAccount(email, currency, account) {
    return api
      .post(`/v1/baas/custody/ramp-accounts`, { email, currency, account })
      .then(pickData);
  },
};

/*
  ── O que saiu deste arquivo ──

  `quoteBrlToUsdt`, `convertBrlToUsdt`, `registerBrlDeposit`, `createCriptoQuote`,
  `withdrawPix`, `postWithdrawPix` e `getHigherDeposit`.

  As três primeiras serviam a conversão BRL ↔ USDT e o depósito em BRL, que saíram da tela:
  esse par passou a ser só no swap, pela mesa. As duas de PIX em lote serviam o envio de
  remessa, que é operação de mesa e não de autoatendimento — e apontavam para
  `/api/v1/criptobnb/subaccounts/...`, rota antiga que já havia sido removida da API por
  ajuste de segurança. `getHigherDeposit` mostrava a chave PIX da Higher para o depósito em
  BRL, que também saiu; a rota continua existindo na API, sem consumidor nesta tela.
*/

export default RampsService;
